import { render, staticRenderFns } from "./ReserveBankAccount.vue?vue&type=template&id=774f205e&"
import script from "./ReserveBankAccount.vue?vue&type=script&lang=js&"
export * from "./ReserveBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./ReserveBankAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports